var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Animate } from "../Animate";
import { TooltipData } from "./data";
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.tooltipData = TooltipData.getInstance;
        _this.body = null;
        _this.elRef = React.createRef();
        return _this;
    }
    Tooltip.prototype.componentDidMount = function () {
        this.body = document.body;
        this.tooltipData.elRef = this.elRef;
        this.body && this.body.addEventListener("mouseenter", this.tooltipData.show, true);
        this.body && this.body.addEventListener("mouseleave", this.tooltipData.hide, true);
    };
    /* istanbul ignore next */
    Tooltip.prototype.componentWillUnmount = function () {
        this.body && this.body.removeEventListener("mouseenter", this.tooltipData.show, true);
        this.body && this.body.removeEventListener("mouseleave", this.tooltipData.hide, true);
    };
    Tooltip.prototype.render = function () {
        var _a = this.tooltipData, isVisible = _a.isVisible, message = _a.message, getPosStyles = _a.getPosStyles;
        return (React.createElement(Animate, { animation: { scale: isVisible ? 1 : 0 }, duration: 100, interruptBehavior: "finish" },
            React.createElement("div", { className: "rj-tooltip rj-desktop-tooltip", style: getPosStyles, ref: this.elRef }, isVisible && (React.createElement("div", { className: "rj-tooltip__message" }, message)))));
    };
    Tooltip = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], Tooltip);
    return Tooltip;
}(React.Component));
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map